import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollContributionCalculation  {
    _originalTypeClassName = "zERP.BO.PayrollContributionCalculation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollContributionCalculation.translate = translateService;
}
this.Rate = 0;
this.Amount = 0;
this.Contribution = 0;
this.Subsidy = 0;
this.PayrollContributionCalculationKey = null;
this._key = this.PayrollContributionCalculationKey = 0; 
}

static translate: TranslateService;
_key: any;
Rate:any;
Amount:any;
Contribution:any;
Subsidy:any;
private _PayrollContributionCalculationKey:any;
get PayrollContributionCalculationKey(): any {
    return this._PayrollContributionCalculationKey;
  }
set PayrollContributionCalculationKey(value: any) {
    this._PayrollContributionCalculationKey = value;
    this._key = value;
  }

static ApplyAmountLimits($this: any, contributionLogSection: any,data: any,rule: any,alreadyInsuredAmount: any): any{if (!(rule?.HasInsuredAmountLimits)) {return;}
let newTotal = Joove.Common.safeNumber(alreadyInsuredAmount) + Joove.Common.safeNumber(data?.Amount);
if (CLMS.Framework.Number.LessThan(() => rule.UpperMonthlyInsuredAmount, () => newTotal)) {data.Amount = Joove.Common.safeNumber(rule?.UpperMonthlyInsuredAmount) - Joove.Common.safeNumber(alreadyInsuredAmount);}else if (CLMS.Framework.Number.GreaterThan(() => rule.LowerMonthlyInsuredAmount, () => newTotal)) {data.Amount = 0;}else {return;}
if (CLMS.Framework.Number.LessThan(() => data.Amount, () => 0)) {data.Amount = 0;}
Domain.TaskLogSection.AddMessage(contributionLogSection, Domain.TaskResultMessageSeverity.Info, "Ποσό μετά την εφαρμογή ορίου: " + Joove.Common.safeNumber(data?.Amount));
}
static ApplyContributionLimits($this: any, contributionLogSection: any,data: any,rule: any): any{if (!(rule?.HasContibutionLimits)) {return;}
if (CLMS.Framework.Number.LessThan(() => rule.UpperMonthlyContributionAmount, () => data.Contribution)) {data.Contribution = rule?.UpperMonthlyContributionAmount;}else if (CLMS.Framework.Number.GreaterThan(() => rule.LowerMonthlyContributionAmount, () => data.Contribution)) {data.Contribution = 0;}else {return;}
Domain.TaskLogSection.AddMessage(contributionLogSection, Domain.TaskResultMessageSeverity.Info, "Εισφορές μετά την εφαρμογή ορίων: " + Joove.Common.safeNumber(data?.Contribution));
}
static CalculateSubsidy($this: any, contributionLogSection: any,rule: any): any{if (!(rule?.Subsidise)) {$this.Subsidy = 0;return;}
if (rule?.SubsidyRules?.CalculationMethod == Domain.ParameterCalculationMethod.Fixed) {if (rule?.SubsidyRules?.IsPercentage) {$this.Subsidy = Joove.Common.safeNumber($this?.Contribution) * Joove.Common.safeNumber((Joove.Common.safeNumber(rule?.SubsidyRules?.ParameterValue) / Joove.Common.safeNumber(100)));}else {$this.Subsidy = rule?.SubsidyRules?.ParameterValue;}}else {throw Error("Subsidy type '" + rule?.SubsidyRules?.CalculationMethod + "' is not yet implemented");}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollContributionCalculationKey == null || $this.PayrollContributionCalculationKey == 0;
            }


}